<template>
    <div>
        <p>Podgląd</p>
        <ul class="list">
            <li class="item"
                v-for="artist in data.artists">
                {{ artist.name }}
            </li>
        </ul>
    </div>
</template>
<script>
    import {ArtistsListWidget} from '@/api/'

    export default {
        props: ["form"],
        data () {
            return {
                previewIsUpdating: false,
                data: []
            }
        },
        methods: {
            updatePreview () {
                if (this.previewIsUpdating) return
                this.previewIsUpdating = true
                ArtistsListWidget.preview(this.form).then(response => {
                    this.previewIsUpdating = false
                    this.data = response.data
                }, error => {
                    this.previewIsUpdating = false
                    console.error(error)
                })
            }
        },
        mounted () {
            this.updatePreview()
        },
        watch: {
            form: {
                handler (value) {
                    this.updatePreview()
                },
                deep: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    .list {
        grid-gap: 20px 20px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
    }

    .item {
        padding: 40px 20px;
        border: 1px solid #333333;
        text-align: center;
        display: grid;
    }
</style>


// WEBPACK FOOTER //
// ArtistsPreview.vue?6fe35583